// @flow
import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';
import type { State } from 'types/redux';
import type { Props } from './SignaturePage';

// Actions
import { goTo } from 'store/reducers/navigation/actions';
import {
  setAppointmentNotes,
  setSelfCheckInSigned,
  checkIn
} from 'store/reducers/selfCheckIn/actions';
import {
  gtmUserEventSignEntered,
  gtmUserEventNotesEntered,
  gtmUserEventSignatureFullScreen,
  gtmUserEventOpenDisclaimerModal,
  gtmCompleteCheckInClick
} from 'store/reducers/gtm/actions';

// Selectors
import {
  getSignature,
  getAppointmentNotes,
  getIsDealerOpenNow
} from 'store/reducers/selfCheckIn/selectors';
import SignaturePage from './SignaturePage';
import { showSCIProgressBar } from 'store/reducers/optimizelyABTest/selectors';

const mapStateToProps = (state: State): $Shape<Props> => ({
  signature: getSignature(state),
  appointmentNotes: getAppointmentNotes(state),
  isDealerOpenNow: getIsDealerOpenNow(state),
  showSCIProgressBar: showSCIProgressBar(state)
});

export default compose(
  withRouter,
  injectIntl,
  connect(
    mapStateToProps,
    {
      goTo,
      setAppointmentNotes,
      setSelfCheckInSigned,
      checkIn,
      gtmUserEventSignEntered,
      gtmUserEventNotesEntered,
      gtmUserEventSignatureFullScreen,
      gtmUserEventOpenDisclaimerModal,
      gtmCompleteCheckInClick
    }
  )
)(SignaturePage);



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/SignaturePage/SignaturePageContainer.js